<template>
  <div>
    <div id="_div" class="w-100 px-5 py-4">
      <div id="Titulo_div">
        <h1>Listas de Acuerdos Publicadas</h1>
      </div>
      <div style="display: flex">
        <div class="col-12 padding-div-low">
          <div class="area">
              <div class="row">
                  <div class="col-3">
                      <b>Fecha de Publicación: </b>
                  </div>
              </div>
              <div class="row">
                  <div class="col-3">
                      <input type="date" class="form-control" v-model="fechaDePublicacion"/>
                  </div>
                  <div class="col-3">
                      <input type="button" class="form-control" value="Buscar" @click="obtenerListasDeAcuerdosPublicadas"/>
                  </div>
              </div>
              <div class="new-row">
                  <TablaListasDeAcuerdosPublicadas 
                  :prop_listasDeAcuerdosPublicadas="listasDeAcuerdosPublicadas" 
                  :key="listaDeAcuerdosKey"/>
              </div>
              <div class="new-row">
                  <TablaAcuerdosDelDia 
                  :prop_acuerdosDelDia="acuerdosDelDia" 
                  :key="listaDeAcuerdosKey"/>
              </div>
          </div>
        </div>
      </div>
  </div>
  </div>
</template>
<script>
import Vue from "vue";
import enumeraciones from "@/../static/js/enumeraciones";
import catalogos from "@/../static/js/catalogos";
import api from "@/../static/js/api";
import comun from "@/../static/js/comun";
import axios from "axios";
import store from "@/store/index";
import TablaListasDeAcuerdosPublicadas from "@/components/SIFA/Reportes/ListasDeAcuerdosPublicadas/TablaListasDeAcuerdosPublicadas.vue";
import TablaAcuerdosDelDia from "@/components/SIFA/Reportes/ListasDeAcuerdosPublicadas/TablaAcuerdosDelDia.vue";
import { ListaDeAcuerdos } from "@/components/SIFA/Comun/Modelos/ListaDeAcuerdos.js";
import { Acuerdo } from "@/components/SIFA/Comun/Modelos/Acuerdo.js";
export default {
  data() {
    return {
        fechaDePublicacion: null,
        listasDeAcuerdosPublicadas: [],
        acuerdosDelDia: [],
        listaDeAcuerdosKey: 0,
    };
  },
  props: {},
  components: {
      TablaListasDeAcuerdosPublicadas,
      TablaAcuerdosDelDia
  },
  methods: {
      obtenerListasDeAcuerdosPublicadas: function() {
      //Retorna una lista de citas 'Aceptadas'
      var peticion = {
        fechaDePublicacion: this.fechaDePublicacion
      };
      comun.SeEstaCargandoInformacion(true);
      axios
        .post(
          api.conexion + api.SIFA.funciones.ObtenerListasDeAcuerdosPublicadas,
          peticion
        )
        .then(response => {
          comun.SeEstaCargandoInformacion(true);
          if (response.data.SiHayError == false) {
            //En caso de que la petición sea exitosa
            this.listasDeAcuerdosPublicadas = response.data.listasDeAcuerdosPublicadas.map(lap => 
            {
            console.log(lap);    
            var nuevaListaDeAcuerdos = new ListaDeAcuerdos();
            nuevaListaDeAcuerdos.constructorObjeto(lap);
            return nuevaListaDeAcuerdos;
            });
            this.acuerdosDelDia = response.data.acuerdosDelDia.map(ad => 
            {var nuevoAcuerdo = new Acuerdo();
            nuevoAcuerdo.constructorObjeto(ad);
            return nuevoAcuerdo;
            });
            this.listaDeAcuerdosKey++;
          } else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null);
          }
          comun.SeEstaCargandoInformacion(false);
        })
        .catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(
            comun.mensajeDeError(enumeraciones.error.E500),
            null,
            null
          );
          comun.SeEstaCargandoInformacion(false);
        });
    },
  },
  mounted: function mounted() {},
  computed: {},
};
</script>

<style scoped>
.new-row {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/SIFA/Reportes/ListasDeAcuerdosPublicadas/ListasDeAcuerdosPublicadas.vue